import WarningCircle from 'components/Icons/WarningCircle';
import s from './NotEditableModal.module.scss';

const NotEditableModalBody: React.FC<{ reason: string }> = ({ reason }) => {
  if (reason === 'is-upgraded' || reason === 'is-upgrading') {
    return (
      <div className={s.body}>
        <WarningCircle weight="fill" size={80} color="var(--color-warning)" />
        <p className="body-sm">This questionnaire is not editable because it has been upgraded. Reload to get the latest version and continue.</p>
      </div>
    );
  }
  if (reason === 'is-submitted') {
    return (
      <div className={s.body}>
        <WarningCircle weight="fill" size={80} color="var(--color-warning)" />
        <p className="body-sm">
          This questionnaire is not editable because it has been submitted. Reload, then click &quot;Edit Responses&quot; to make changes.
        </p>
      </div>
    );
  }
  return (
    <div className={s.body}>
      <WarningCircle weight="fill" size={80} color="var(--color-warning)" />
      <p className="body-sm">This questionnaire is not editable, contact support.</p>
    </div>
  );
};

export default NotEditableModalBody;
